export default __webpack_public_path__ + "static/media/girl5.9ee4bff1.jpg";